import Link from 'next/link'
import { Card } from 'react-bootstrap'

import { extractFirstImageSource } from '@portal/news-lib/extract-image'

import placeholderImage from '@/shared/assets/placeholder.png'
import { getPostLink } from '@/shared/lib/post-link'
import type { PostFeatured } from '@/shared/newsdb'

import { carouselPostRecipe } from './recipe'

type CarouselCardProps = {
    post: PostFeatured
}

export function CarouselPost({ post }: CarouselCardProps) {
    const href = getPostLink({ label: post.label, slug: post.slug })
    const src = extractFirstImageSource(post.content)
    const styles = carouselPostRecipe()

    return (
        <Card>
            <Link href={href} target="_blank">
                <Card.Img
                    className={styles.cardImage}
                    variant="top"
                    src={src ?? placeholderImage.src}
                    draggable={false}
                />
            </Link>
            <Card.Body className={styles.cardBody}>
                <h2 className={styles.titleHeading}>
                    <Link href={href} target="_blank" prefetch={false} className={styles.titleLink}>
                        {post.title}
                    </Link>
                </h2>
            </Card.Body>
        </Card>
    )
}
